/* ============================================================
   THOUSAND ISLANDS PHARMACY — THEME JS
   ============================================================ */

(function () {
  'use strict';

  /* --- Scroll lock for drawers (touch devices) --------------- */
  /* body{overflow:hidden} alone locks nothing here: html has overflow-x:
     clip, so body's overflow no longer propagates to the viewport, and iOS
     ignores it for touch anyway. On coarse-pointer devices lock the root and
     pin the body at the current scroll; restore both on unlock. Desktop keeps
     its previous behaviour (no lock, no scrollbar jump). */
  var scrollLockY = 0, scrollLocks = 0;
  var coarsePointerMQ = window.matchMedia('(hover: none), (pointer: coarse)');
  function lockScroll() {
    if (scrollLocks++ > 0) return;
    if (!coarsePointerMQ.matches) {
      /* Desktop (2026-09-03 desktop audit P2-4): hide the root scrollbar;
         theme.css reserves its gutter so the page does not shift. */
      document.documentElement.classList.add('scroll-locked');
      return;
    }
    scrollLockY = window.scrollY;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollLockY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockScroll() {
    if (scrollLocks === 0 || --scrollLocks > 0) return;
    document.documentElement.classList.remove('scroll-locked');
    if (document.body.style.position !== 'fixed') return;
    document.documentElement.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollLockY);
  }

  /* --- Escape layering (2026-09-03 desktop audit P3-10) --------
     Only the top-most open layer answers Escape. The vars are hoisted and
     assigned below; every key event fires long after that. */
  function topLayer() {
    if (cartDrawer && cartDrawer.classList.contains('open')) return 'cart';
    if (filterSidebar && filterSidebar.classList.contains('open')) return 'filters';
    if (headerSearchPanel && !headerSearchPanel.hidden) return 'search';
    if (document.querySelector('.nav-dropdown-toggle[aria-expanded="true"]')) return 'dropdown';
    if (mobileNav && mobileNav.classList.contains('open')) return 'nav';
    return null;
  }

  /* --- Mobile Menu ----------------------------------------- */
  var menuBtn   = document.querySelector('.mobile-menu-btn');
  var mobileNav = document.querySelector('.mobile-nav');
  var closeSearchPanelFn = null;   /* set once the search panel is wired below */
  if (menuBtn && mobileNav) {
    /* The drawer sits inside the sticky header, so it can never be taller
       than the space under its own top edge: cap it at open time (and on
       scroll/resize while open) and let it scroll internally. theme.css
       carries a dvh fallback for the no-JS case. Desktop never opens it. */
    function fitMobileNav() {
      if (!mobileNav.classList.contains('open')) { mobileNav.style.maxHeight = ''; return; }
      var top = mobileNav.getBoundingClientRect().top;
      mobileNav.style.maxHeight = Math.max(200, window.innerHeight - top - 8) + 'px';
    }
    menuBtn.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', String(open));
      if (open && closeSearchPanelFn) closeSearchPanelFn(false);   /* never both open */
      fitMobileNav();
    });
    window.addEventListener('resize', fitMobileNav, { passive: true });
    window.addEventListener('scroll', fitMobileNav, { passive: true });
    document.addEventListener('click', function (e) {
      if (!menuBtn.contains(e.target) && !mobileNav.contains(e.target)) {
        mobileNav.classList.remove('open');
        menuBtn.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && topLayer() === 'nav') {
        mobileNav.classList.remove('open');
        menuBtn.setAttribute('aria-expanded', 'false');
        menuBtn.focus();
      }
    });
  }

  /* --- Mobile Nav Collapsible Groups (Services AND Products) -- */
  document.querySelectorAll('.mobile-nav-group-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var sub      = document.getElementById(this.getAttribute('aria-controls'));
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      if (sub) sub.classList.toggle('open', !expanded);
    });
  });

  /* --- Auto-close mobile menu at desktop width -------------- */
  var desktopMQ = window.matchMedia('(min-width: 1181px)');  /* hamburger is available up to 1180px */
  function closeMobileNavAtDesktop(mq) {
    if (mq.matches && mobileNav && mobileNav.classList.contains('open')) {
      mobileNav.classList.remove('open');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    }
  }
  if (desktopMQ.addEventListener) desktopMQ.addEventListener('change', closeMobileNavAtDesktop);
  else if (desktopMQ.addListener) desktopMQ.addListener(closeMobileNavAtDesktop);

  /* --- Sticky Header: glass fallback ------------------------- */
  /* 2026-08-14 (owner): the hide/reveal is gone — the floating header
     stays put while you scroll, wearing the glass morph. This .scrolled
     toggle only feeds the no-scroll-driven-animation CSS fallback. */
  var header = document.querySelector('.site-header');
  var glassIsCss = window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()') &&
                   !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (header && !glassIsCss) {
    var headerScrolled = false;
    var onScroll = function () {
      var y = window.scrollY;
      if (!headerScrolled && y > 20) {
        header.classList.add('scrolled');
        headerScrolled = true;
      } else if (headerScrolled && y < 5) {
        header.classList.remove('scrolled');
        headerScrolled = false;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- Header search panel (desktop) ------------------------ */
  var headerSearchToggle = document.getElementById('header-search-toggle');
  var headerSearchPanel  = document.getElementById('header-search-panel');
  if (headerSearchToggle && headerSearchPanel) {
    var searchSiteHeader = headerSearchPanel.closest('.site-header');
    headerSearchToggle.addEventListener('click', function () {
      var willOpen = headerSearchPanel.hidden;
      headerSearchPanel.hidden = !willOpen;
      headerSearchToggle.setAttribute('aria-expanded', String(willOpen));
      /* .search-open lets CSS suppress the hover-opened nav menus — the
         panel overlays the nav's territory and a menu bleeding through the
         suggestions reads as clutter. Collapse any click-expanded one too. */
      if (searchSiteHeader) searchSiteHeader.classList.toggle('search-open', willOpen);
      if (willOpen) {
        if (mobileNav && mobileNav.classList.contains('open')) {   /* never both open */
          mobileNav.classList.remove('open');
          if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
        }
        document.querySelectorAll('.nav-dropdown-toggle[aria-expanded="true"]').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
        var inp = headerSearchPanel.querySelector('[data-search-input]');
        if (inp) inp.focus();
      }
    });
    function closeSearchPanel(returnFocus) {
      if (headerSearchPanel.hidden) return;
      headerSearchPanel.hidden = true;
      headerSearchToggle.setAttribute('aria-expanded', 'false');
      if (searchSiteHeader) searchSiteHeader.classList.remove('search-open');
      if (returnFocus) headerSearchToggle.focus({ preventScroll: true });
    }
    closeSearchPanelFn = closeSearchPanel;
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && topLayer() === 'search') closeSearchPanel(true);
    });
    /* Phones/tablets (hamburger range): the toggle sits in the utility bar
       that scrolls away while the panel stays pinned under the sticky
       header, so an open panel used to strand itself with no visible way
       out. Close on a tap outside it, on submit, and from the panel's own
       close button. Desktop keeps toggle + Escape only. */
    var searchTouchMQ = window.matchMedia('(max-width: 1180px)');
    var headerSearchClose = headerSearchPanel.querySelector('.header-search-close');
    if (headerSearchClose) headerSearchClose.addEventListener('click', function () { closeSearchPanel(true); });
    /* 2026-09-03 desktop audit P2-3: outside click and Tab-out close the
       band at EVERY width (desktop used to leave an empty white band open). */
    document.addEventListener('pointerdown', function (e) {
      if (headerSearchPanel.hidden) return;
      if (headerSearchPanel.contains(e.target) || headerSearchToggle.contains(e.target)) return;
      closeSearchPanel(false);
    });
    headerSearchPanel.addEventListener('focusout', function (e) {
      var t = e.relatedTarget;
      if (!t || headerSearchPanel.hidden) return;
      if (headerSearchPanel.contains(t) || headerSearchToggle.contains(t)) return;
      closeSearchPanel(false);
    });
    var headerSearchForm = headerSearchPanel.querySelector('form');
    if (headerSearchForm) headerSearchForm.addEventListener('submit', function () {
      closeSearchPanel(false);
    });
  }

  /* --- Active Nav Link -------------------------------------- */
  var currentPath = window.location.pathname;
  document.querySelectorAll('.header-nav a, .mobile-nav a').forEach(function (link) {
    var href = link.getAttribute('href');
    if (href === currentPath || (href !== '/' && currentPath.startsWith(href))) {
      link.classList.add('active');
      link.setAttribute('aria-current', 'page');
    }
  });

  /* --- Back link (was an inline onclick) --------------------- */
  document.querySelectorAll('[data-back-link]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (history.length > 1 && document.referrer.indexOf(location.origin) === 0) { e.preventDefault(); history.back(); }
    });
  });

  /* --- Contact Form: Pre-fill subject from URL -------------- */
  /* URLSearchParams already decodes the value (handles + and %xx),
     so do NOT decode again — double-decoding throws on a literal % in the query. */
  var urlParams    = new URLSearchParams(window.location.search);
  var subjectParam = urlParams.get('subject');
  if (subjectParam) {
    var subjectField = document.getElementById('contact-subject');
    if (subjectField) subjectField.value = subjectParam;
  }

  /* --- Contact Form: keep the confirmation/error in view after submit ------
     Shopify does a full-page POST: on success it reloads with
     ?contact_posted=true#contact_form, on validation error it re-renders the
     POST. Either way the browser lands at the top of the page, hiding the
     message that renders far down the form column. Scroll the rendered notice
     into view and move focus to it (the divs carry tabindex="-1") so keyboard
     and screen-reader users land on the message. Keyed on DOM presence, so it
     covers both the success and error states. */
  var contactNotice = document.getElementById('contact-success') ||
                      document.getElementById('contact-errors');
  if (contactNotice) {
    contactNotice.scrollIntoView({ behavior: 'auto', block: 'center' });
    contactNotice.focus({ preventScroll: true });
  }

  /* --- FAQ Accordion ---------------------------------------- */
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = this.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
      document.querySelectorAll('.faq-question').forEach(function (b) {
        var wrap = b.closest('.faq-item');
        b.setAttribute('aria-expanded', String(!!(wrap && wrap.classList.contains('open'))));
      });
    });
  });

  /* --- Product Gallery Thumbnails --------------------------- */
  document.querySelectorAll('.gallery-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('gallery-main-img');
      var videoWrap = document.getElementById('gallery-video-wrap');

      if (this.classList.contains('gallery-thumb--video')) {
        if (mainImg) mainImg.style.display = 'none';
        if (videoWrap) videoWrap.style.display = 'block';
      } else {
        if (videoWrap) {
          var vid = videoWrap.querySelector('video');
          if (vid) vid.pause();
          videoWrap.style.display = 'none';
        }
        if (mainImg) {
          mainImg.style.display = '';
          var thumbImg = this.querySelector('img');
          if (thumbImg) {
            /* Swap in the full-size rendition (data-full/data-srcset) — assigning
               the 160px thumbnail file upscaled it into the main well (blurry). */
            mainImg.src = this.dataset.full || thumbImg.src;
            if (this.dataset.srcset) { mainImg.srcset = this.dataset.srcset; }
            mainImg.alt = thumbImg.alt;
          }
        }
      }

      document.querySelectorAll('.gallery-thumb').forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-pressed', 'false');
        t.setAttribute('tabindex', '-1');
      });
      this.classList.add('active');
      this.setAttribute('aria-pressed', 'true');
      this.setAttribute('tabindex', '0');
    });
    /* Roving tabindex (2026-09-03 desktop audit P3-8): one Tab stop, the
       arrow keys move between thumbs and select as they go. */
    thumb.addEventListener('keydown', function (e) {
      var all = Array.prototype.slice.call(document.querySelectorAll('.gallery-thumb'));
      var i = all.indexOf(this), next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = all[(i + 1) % all.length];
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = all[(i - 1 + all.length) % all.length];
      else if (e.key === 'Home') next = all[0];
      else if (e.key === 'End') next = all[all.length - 1];
      if (!next) return;
      e.preventDefault();
      next.focus();
      next.click();
    });
    if (!thumb.hasAttribute('aria-pressed')) thumb.setAttribute('aria-pressed', thumb.classList.contains('active') ? 'true' : 'false');
    if (!thumb.hasAttribute('tabindex')) thumb.setAttribute('tabindex', thumb.classList.contains('active') ? '0' : '-1');
  });

  /* --- Intersection Observer: Fade-in cards ----------------- */
  var fadeObserver = null;
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    fadeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.product-card, .value-card').forEach(function (el) {
      el.classList.add('fade-in-up');
      fadeObserver.observe(el);
    });
  }

  /* --- Nav Dropdown (desktop nav only: hidden by CSS up to 1180px) ---- */
  /* Bound at every width (2026-09-03 desktop audit P2-1): gating on
     desktopMQ at load left a window that was widened later with dead
     toggles. The buttons are display:none below 1181px, so this is free. */
  var hoverMQ = window.matchMedia('(hover: hover) and (pointer: fine)');
  document.querySelectorAll('.nav-dropdown-toggle').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var byPointer = e.detail > 0 && hoverMQ.matches;
      document.querySelectorAll('.nav-dropdown-toggle').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      /* Mouse users already see the menu on hover: a click keeps it open
         (mouseleave below releases it) instead of toggling it shut under
         the pointer. Keyboard and touch toggle as before. */
      if (byPointer || !expanded) this.setAttribute('aria-expanded', 'true');
    });
  });
  document.querySelectorAll('.nav-dropdown').forEach(function (dd) {
    var toggle = dd.querySelector('.nav-dropdown-toggle');
    if (!toggle) return;
    dd.addEventListener('mouseenter', function () {
      if (!hoverMQ.matches) return;
      document.querySelectorAll('.nav-dropdown-toggle').forEach(function (b) { if (b !== toggle) b.setAttribute('aria-expanded', 'false'); });
      toggle.setAttribute('aria-expanded', 'true');
    });
    dd.addEventListener('mouseleave', function () {
      if (!hoverMQ.matches) return;
      /* keep a keyboard-opened menu if focus is still inside it */
      if (dd.contains(document.activeElement) && document.activeElement !== toggle) return;
      toggle.setAttribute('aria-expanded', 'false');
    });
    dd.addEventListener('focusout', function (e) {
      if (e.relatedTarget && dd.contains(e.relatedTarget)) return;
      toggle.setAttribute('aria-expanded', 'false');
    });
    /* Arrow keys (2026-09-03 desktop audit P3-1) */
    var menu = dd.querySelector('.nav-dropdown-menu');
    if (!menu) return;
    toggle.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown') return;
      e.preventDefault();
      document.querySelectorAll('.nav-dropdown-toggle').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      toggle.setAttribute('aria-expanded', 'true');
      var first = menu.querySelector('a');
      if (first) first.focus();
    });
    menu.addEventListener('keydown', function (e) {
      var links = Array.prototype.slice.call(menu.querySelectorAll('a'));
      var i = links.indexOf(document.activeElement);
      if (i === -1) return;
      var next = null;
      if (e.key === 'ArrowDown') next = links[(i + 1) % links.length];
      else if (e.key === 'ArrowUp') next = links[(i - 1 + links.length) % links.length];
      else if (e.key === 'Home') next = links[0];
      else if (e.key === 'End') next = links[links.length - 1];
      if (!next) return;
      e.preventDefault();
      next.focus();
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav-dropdown')) {
      document.querySelectorAll('.nav-dropdown-toggle').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || topLayer() !== 'dropdown') return;
    document.querySelectorAll('.nav-dropdown-toggle[aria-expanded="true"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      var dd = b.closest('.nav-dropdown');
      if (dd && dd.contains(document.activeElement)) b.focus();
    });
  });

  /* --- Smooth scroll for anchor links ----------------------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      var target = null;
      try { target = (href && href.length > 1) ? document.querySelector(href) : null; } catch (err) { target = null; }
      if (target) {
        e.preventDefault();
        try { history.pushState(null, '', href); } catch (err2) {}
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
        /* Move focus as well: the skip link (and any in-page link) has to
           land keyboard and screen-reader users on the target, not just
           scroll it under them. */
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    });
  });

  /* ============================================================
     CART & E-COMMERCE
     ============================================================ */

  /* --- Helpers --------------------------------------------- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartCount(count) {
    var badges = [
      document.getElementById('cart-count'),
      document.getElementById('mobile-nav-cart-count')
    ];
    var sr = document.getElementById('cart-count-sr');
    if (sr) sr.textContent = count + ' item' + (count === 1 ? '' : 's');
    badges.forEach(function(badge) {
      if (!badge) return;
      badge.textContent = count;
      if (count > 0) {
        badge.classList.remove('hidden');
      } else {
        badge.classList.add('hidden');
      }
    });
  }

  /* --- Cart status: SR announcements + error toast ----------- */
  function announceCart(message) {
    var region = document.getElementById('cart-status');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(function () { region.textContent = message; }, 60);
  }

  var cartToastTimer = null;
  function showCartError(message) {
    var toast = document.getElementById('cart-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    if (cartToastTimer) { window.clearTimeout(cartToastTimer); }
    cartToastTimer = window.setTimeout(function () { toast.hidden = true; }, 5000);
  }

  /* --- Cart Drawer ------------------------------------------ */
  var cartDrawer  = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-overlay');
  var drawerClose = document.getElementById('cart-drawer-close');
  var cartIconBtn = document.getElementById('cart-icon-btn');

  var cartDrawerReturnFocus = null;
  var cartDrawerAnimTimer = null;

  /* Closed drawer + overlay are display:none (Safari 26 chrome-samples any
     fixed element touching the top edge, hidden or not). Open: mount via
     .is-animating, force a layout, then .open so the 0.3s slide still
     transitions. Close: hold .is-animating for the slide-out, then the CSS
     :not() rule unmounts them. */
  function cartDrawerSettle() {
    clearTimeout(cartDrawerAnimTimer);
    cartDrawerAnimTimer = setTimeout(function () {
      cartDrawer.classList.remove('is-animating');
      if (cartOverlay) cartOverlay.classList.remove('is-animating');
    }, 350);
  }

  var inertWhileDrawer = ['#main-content', '#shopify-section-header', '#shopify-section-utility-bar', '#shopify-section-footer'];
  function setPageInert(on) {
    inertWhileDrawer.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
  }
  function openCartDrawer(cartData) {
    if (!cartDrawer) return;
    cartDrawerReturnFocus = document.activeElement;
    var drawerBody = document.getElementById('cart-drawer-body');
    if (drawerBody && !drawerBody.children.length) {
      drawerBody.innerHTML = '<div class="cart-drawer-empty" aria-busy="true"><span class="infinite-spinner" aria-hidden="true"></span><p>Loading your cart…</p></div>';
    }
    setPageInert(true);
    cartDrawer.classList.add('is-animating');
    if (cartOverlay) cartOverlay.classList.add('is-animating');
    void cartDrawer.offsetWidth;
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    cartDrawerSettle();
    lockScroll();
    if (cartData) { renderCartDrawer(cartData); updateCartCount(cartData.item_count); }
    else fetchAndRenderCart();
    if (drawerClose) drawerClose.focus({ preventScroll: true });
  }

  function closeCartDrawer() {
    if (!cartDrawer || !cartDrawer.classList.contains('open')) return;
    cartDrawer.classList.add('is-animating');
    if (cartOverlay) cartOverlay.classList.add('is-animating');
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    cartDrawerSettle();
    unlockScroll();
    setPageInert(false);
    if (cartDrawerReturnFocus && document.contains(cartDrawerReturnFocus)) {
      cartDrawerReturnFocus.focus({ preventScroll: true });
    }
    cartDrawerReturnFocus = null;
  }

  if (cartIconBtn) {
    cartIconBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  if (drawerClose)  drawerClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay)  cartOverlay.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && topLayer() === 'cart') closeCartDrawer();
  });
  /* Keep Tab inside the open drawer — it declares aria-modal */
  if (cartDrawer) {
    cartDrawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !cartDrawer.classList.contains('open')) return;
      var els = cartDrawer.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]):not([type="hidden"]), select:not([disabled])');
      if (!els.length) return;
      var first = els[0];
      var last  = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* --- Cart: progress toward the lower shipping rate ----------------------
     Same markup as snippets/ship-progress.liquid; the threshold and rates come
     from the data-ship-* settings on #cart-drawer. (tipt-142) */
  function shipProgressInner(totalCents) {
    var ship = (cartDrawer && cartDrawer.dataset) || {};
    var under = parseFloat(ship.shipUnder || '13.95');
    var over = parseFloat(ship.shipOver || '8.95');
    var thresholdCents = Math.round(parseFloat(ship.shipThreshold || '135') * 100) || 13500;
    var pct = Math.min(100, Math.round((totalCents / thresholdCents) * 100));
    var saving = (under - over).toFixed(2);
    var msg = totalCents >= thresholdCents
      ? 'You unlocked $' + over.toFixed(2) + ' shipping, a $' + saving + ' saving.'
      : 'Add <strong>' + formatMoney(thresholdCents - totalCents) + '</strong> more to save $' + saving + ' on shipping.';
    return '<p class="ship-progress-msg">' + msg + '</p>' +
      '<div class="ship-progress-track" role="progressbar" aria-label="Progress toward lower shipping" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '">' +
        '<span class="ship-progress-fill' + (pct >= 100 ? ' is-done' : '') + '" style="width:' + pct + '%"></span>' +
      '</div>';
  }
  function updateShipProgress(totalCents) {
    document.querySelectorAll('[data-ship-progress]').forEach(function (el) {
      el.innerHTML = shipProgressInner(totalCents);
    });
  }

  /* "How did you hear about us?" is a cart attribute, like the delivery
     options, so it lands on the order in admin (checkout pages are not
     editable on this plan). Options mirror snippets/cart-extras.liquid. */
  var HEARD_ABOUT = ['Google search', 'Google Maps', 'Facebook', 'Friend or family', 'Doctor, nurse or clinic', 'I shop in the store', 'Other'];
  function heardAboutHtml(current) {
    var opts = '<option value="">Choose one (optional)</option>';
    HEARD_ABOUT.forEach(function (o) {
      opts += '<option value="' + o + '"' + (current === o ? ' selected' : '') + '>' + o + '</option>';
    });
    return '<label class="cart-heard"><span>How did you hear about us?</span>' +
      '<select data-cart-attribute="How did you hear about us">' + opts + '</select></label>';
  }

  /* --- Fetch and Render Cart Drawer ------------------------- */
  function fetchAndRenderCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); updateCartCount(cart.item_count); })
      .catch(function () { renderCartDrawerError(); });
  }

  function renderCartDrawer(cart) {
    var body   = document.getElementById('cart-drawer-body');
    var footer = document.getElementById('cart-drawer-footer');
    if (!body || !footer) return;
    /* Shipping numbers come from theme settings via data-ship-* on the
       drawer (layout/theme.liquid), so a rate change is one Customize edit. */
    var ship = (cartDrawer && cartDrawer.dataset) || {};
    var shipUnder = ship.shipUnder || '13.95';
    var shipOver = ship.shipOver || '8.95';
    var shipThresholdLabel = ship.shipThreshold || '135';
    var shipThresholdCents = Math.round(parseFloat(shipThresholdLabel) * 100) || 13500;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer-empty">' +
        '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#D4D8DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
        '<p>Your cart is empty.</p>' +
        '<a href="/collections/all" class="btn btn-primary" style="margin-top:0.5rem; border-radius:4px;">Browse Products</a>' +
        '</div>';
      footer.innerHTML = '';
      return;
    }

    var itemsHtml = '';
    cart.items.forEach(function (item) {
      var imgSrc = item.image ? item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=144' : '';
      var imgHtml = item.image
        ? '<img class="drawer-item-img" src="' + imgSrc + '" alt="" width="72" height="72" loading="lazy">'
        : '<div class="drawer-item-img-placeholder"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#D4D8DA" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg></div>';
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="drawer-item-variant">' + escapeHtml(item.variant_title) + '</span>'
        : '';
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        variantHtml += '<span class="drawer-item-variant">' + escapeHtml(item.selling_plan_allocation.selling_plan.name) + '</span>';
      }
      itemsHtml +=
        '<div class="drawer-item" data-key="' + item.key + '">' +
          '<a href="' + item.url + '" tabindex="-1" aria-hidden="true">' + imgHtml + '</a>' +
          '<div class="drawer-item-info">' +
            '<a href="' + item.url + '" class="drawer-item-title">' + escapeHtml(item.product_title) + '</a>' +
            variantHtml +
            '<span class="drawer-item-price">' + formatMoney(item.final_line_price) + '</span>' +
            '<div class="drawer-item-qty">' +
              '<div class="drawer-qty-selector">' +
                '<button type="button" class="drawer-qty-btn drawer-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '"' + (item.quantity <= 1 ? ' disabled' : '') + ' aria-label="Decrease quantity of ' + escapeHtml(item.product_title) + '">−</button>' +
                '<input type="number" inputmode="numeric" pattern="[0-9]*" class="drawer-qty-val" value="' + item.quantity + '" min="0" max="99" data-key="' + item.key + '" aria-label="Quantity of ' + escapeHtml(item.product_title) + '">' +
                '<button type="button" class="drawer-qty-btn drawer-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity of ' + escapeHtml(item.product_title) + '">+</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="drawer-item-remove" data-key="' + item.key + '" aria-label="Remove ' + escapeHtml(item.product_title) + '">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
        '</div>';
    });
    body.innerHTML = itemsHtml;

    footer.innerHTML =
      '<div class="cart-drawer-subtotal">' +
        '<span>Subtotal</span>' +
        '<span>' + formatMoney(cart.total_price) + '</span>' +
      '</div>' +
      '<div class="ship-progress" data-ship-progress>' + shipProgressInner(cart.total_price) + '</div>' +
      '<p class="cart-drawer-subtotal-note">' +
        (cart.total_price >= shipThresholdCents
          ? 'Your order ships for $' + shipOver + '. '
          : 'Shipping $' + shipUnder + '. Orders $' + shipThresholdLabel + '+ ship for $' + shipOver + '. ') +
        'Taxes calculated at checkout.</p>' +
      /* Delivery preference: saved as a cart attribute (lands on the order's
         "Additional details" in admin). Mirrors the cart-page checkbox. (2026-10-05) */
      '<div class="cart-delivery-opts">' +
        '<label class="cart-opt">' +
          '<input type="checkbox" data-cart-attribute="Signature required on delivery" value="Yes" data-saved-msg="Saved: a signature will be required."' +
            ((cart.attributes && cart.attributes['Signature required on delivery'] === 'Yes') ? ' checked' : '') + '>' +
          '<span class="cart-opt-text"><strong>Require a signature on delivery</strong>' +
          '<small>Free. The courier will not leave the parcel unattended.</small></span>' +
        '</label>' +
        '<label class="cart-opt">' +
          '<input type="checkbox" data-cart-attribute="Insurance receipt requested" value="Yes" data-saved-msg="Saved: we will email an insurance receipt."' +
            ((cart.attributes && cart.attributes['Insurance receipt requested'] === 'Yes') ? ' checked' : '') + '>' +
          '<span class="cart-opt-text"><strong>Email me a receipt for insurance</strong>' +
          '<small>Itemized, with our pharmacy details, for your benefits claim.</small></span>' +
        '</label>' +
        heardAboutHtml(cart.attributes && cart.attributes['How did you hear about us']) +
        '<span class="cart-opt-status" data-cart-attribute-status aria-live="polite"></span>' +
      '</div>' +
      '<a href="/checkout" class="cart-checkout-btn-full">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>' +
        'Checkout' +
      '</a>' +
      '<a href="/cart" class="cart-view-link">View full cart</a>';

    bindDrawerEvents();
  }

  function renderCartDrawerError() {
    var body = document.getElementById('cart-drawer-body');
    if (body) body.innerHTML = '<div class="cart-drawer-empty"><p>Could not load cart. <a href="/cart">View cart page</a>.</p></div>';
  }

  function bindDrawerEvents() {
    /* Qty minus/plus buttons */
    document.querySelectorAll('.drawer-minus, .drawer-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.dataset.key;
        var qty = parseInt(this.dataset.qty, 10);
        lastDrawerControl = { key: key, cls: this.classList.contains('drawer-plus') ? 'drawer-plus' : 'drawer-minus' };
        changeCartItem(key, qty);
      });
    });
    /* Qty input change */
    document.querySelectorAll('.drawer-qty-val').forEach(function (input) {
      input.addEventListener('change', function () {
        var key = this.dataset.key;
        var n = parseInt(this.value, 10);
        /* An emptied field (the phone way to retype a number) must not read
           as zero and delete the line; put the old value back instead. */
        if (this.value.trim() === '' || isNaN(n) || n < 0) { this.value = this.defaultValue; return; }
        if (n > 99) { n = 99; this.value = '99'; }
        lastDrawerControl = { key: key, cls: 'drawer-qty-val' };
        changeCartItem(key, n);
      });
    });
    /* Remove buttons */
    document.querySelectorAll('.drawer-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeCartItem(this.dataset.key, 0);
      });
    });
  }

  var lastDrawerControl = null;
  /* Re-rendering the drawer body destroys the control that was tapped and
     drops focus to the page (outside the aria-modal dialog); put it back. */
  function refocusDrawer() {
    if (!cartDrawer || !cartDrawer.classList.contains('open')) return;
    var el = null;
    if (lastDrawerControl) el = cartDrawer.querySelector('.' + lastDrawerControl.cls + '[data-key="' + lastDrawerControl.key + '"]');
    lastDrawerControl = null;
    (el || drawerClose || cartDrawer).focus({ preventScroll: true });
  }
  var cartChangeSeq = 0;
  function setRowBusy(key, busy) {
    if (!cartDrawer) return;
    cartDrawer.querySelectorAll('[data-key="' + key + '"]').forEach(function (el) { if ('disabled' in el) el.disabled = busy; });
  }
  function changeCartItem(key, quantity) {
    var seq = ++cartChangeSeq;   /* a newer change supersedes this one */
    setRowBusy(key, true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { if (!r.ok) { throw new Error('cart-change-failed'); } return r.json(); })
      .then(function (cart) {
        if (seq !== cartChangeSeq) return;
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
        refocusDrawer();
        announceCart('Cart updated. ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ' in cart.');
      })
      .catch(function () {
        setRowBusy(key, false);
        showCartError('Could not update the cart. Please try again.');
        announceCart('Could not update the cart. Please try again.');
      });
  }

  /* --- Add to Cart ------------------------------------------ */
  function addToCart(variantId, quantity, btn, sellingPlan) {
    var payload = { id: variantId, quantity: quantity || 1 };
    if (sellingPlan) payload.selling_plan = sellingPlan;   /* subscribe & save (tipt-142) */
    if (btn) {
      btn.classList.add('loading');
      btn.textContent = 'Adding…';
      btn.disabled = true;                 /* a double tap must not add twice */
      btn.setAttribute('aria-busy', 'true');
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) {
          /* Shopify answers 422 with a description (sold out, limit reached):
             surface it instead of blaming the connection. */
          return r.json().catch(function () { return {}; }).then(function (d) {
            var err = new Error('cart-add-failed');
            err.userMessage = d && (d.description || d.message);
            throw err;
          });
        }
        return r.json();
      })
      .then(function () {
        /* The add succeeded whatever happens to this read: never report it
           as a failed add. */
        return fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; });
      })
      .then(function (cart) {
        /* Re-enable BEFORE opening so the drawer's return-focus snapshot is
           the button (Firefox blurs a control the moment it is disabled). */
        if (btn) {
          btn.classList.remove('loading');
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.innerHTML = btn.dataset.originalHtml || 'Add to Cart';
          btn.focus({ preventScroll: true });
        }
        if (cart) {
          updateCartCount(cart.item_count);
          openCartDrawer(cart);   /* one read feeds the drawer (was fetched twice) */
          announceCart('Added to cart. ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ' in cart.');
        } else {
          openCartDrawer();
          announceCart('Added to cart.');
        }
      })
      .catch(function (err) {
        var msg = (err && err.userMessage) || 'Could not add to cart. Please check your connection and try again.';
        showCartError(msg);
        announceCart(msg);
        if (btn) {
          btn.classList.remove('loading');
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.innerHTML = btn.dataset.originalHtml || 'Add to Cart';
        }
      });
  }

  /* --- Quick Add (product cards) ---------------------------- */
  function bindQuickAdd(scope) {
    (scope || document).querySelectorAll('.product-quick-add:not([data-bound])').forEach(function (btn) {
      btn.dataset.bound = '1';
      btn.dataset.originalHtml = btn.innerHTML;
    });
    /* Cards appended by infinite scroll join the fade-in too. */
    if (fadeObserver && scope) {
      scope.querySelectorAll('.product-card:not(.fade-in-up)').forEach(function (el) {
        el.classList.add('fade-in-up');
        fadeObserver.observe(el);
      });
    }
  }
  bindQuickAdd(document);
  /* One delegated listener instead of one per card (infinite scroll used
     to add another batch of listeners on every page). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-quick-add');
    if (!btn) return;
    if (!btn.dataset.originalHtml) btn.dataset.originalHtml = btn.innerHTML;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    addToCart(parseInt(variantId, 10), 1, btn);
  });

  /* --- Product Detail: Variant Selector --------------------- */
  var variants = null;
  var variantsEl = document.getElementById('product-variants-json');
  if (variantsEl) { try { variants = JSON.parse(variantsEl.textContent); } catch (e) {} }
  if (variants && variants.length > 0) {
    var selectedOptions = [];
    // Initialise selectedOptions from active pills
    document.querySelectorAll('#variant-selector .variant-pills').forEach(function (group, idx) {
      var active = group.querySelector('.variant-pill.active');
      selectedOptions[idx] = active ? active.dataset.value : group.querySelector('.variant-pill').dataset.value;
    });

    function variantOptions(v) {
      return [v.option1, v.option2, v.option3].filter(function (o) { return o !== null && o !== undefined; });
    }
    function findVariant(opts) {
      var found = null;
      variants.forEach(function (v) {
        if (found) return;
        var vo = variantOptions(v);
        if (vo.length === opts.length && vo.every(function (o, i) { return o === opts[i]; })) found = v;
      });
      return found;
    }
    /* Paint every group from selectedOptions and mark the values that would
       produce no variant with the other groups as they are (dashed pill). */
    function syncPills() {
      document.querySelectorAll('#variant-selector .variant-pills').forEach(function (group, idx) {
        group.querySelectorAll('.variant-pill').forEach(function (p) {
          var on = p.dataset.value === selectedOptions[idx];
          p.classList.toggle('active', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
          var trial = selectedOptions.slice(); trial[idx] = p.dataset.value;
          p.classList.toggle('unavailable', !findVariant(trial));
        });
        var labelVal = document.getElementById('option-val-' + idx);
        if (labelVal) labelVal.textContent = selectedOptions[idx];
      });
    }

    document.querySelectorAll('.variant-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = parseInt(this.dataset.optionIndex, 10);
        var val = this.dataset.value;
        selectedOptions[idx] = val;
        /* No such combination (partial option matrices): snap the other
           groups to the first real variant that carries the chosen value. */
        if (!findVariant(selectedOptions)) {
          var near = null;
          variants.forEach(function (v) { if (!near && variantOptions(v)[idx] === val) near = v; });
          if (near) selectedOptions = variantOptions(near);
        }
        syncPills();
        updateSelectedVariant();
      });
    });

    function updateSelectedVariant() {
      var match = findVariant(selectedOptions);
      if (!match) return;

      var idInput = document.getElementById('selected-variant-id');
      if (idInput) idInput.value = match.id;

      /* 2026-09-03 desktop audit P2-14: the choice survives refresh, share and
         Back; the Item number row and the gallery follow the variant. */
      try {
        var vurl = new URL(window.location.href);
        if (String(vurl.searchParams.get('variant')) !== String(match.id)) {
          vurl.searchParams.set('variant', match.id);
          history.replaceState(history.state, '', vurl.toString());
        }
      } catch (e) {}
      var skuEl = document.querySelector('[data-product-sku]');
      if (skuEl && match.sku) skuEl.textContent = match.sku;
      if (match.featured_image && match.featured_image.id) {
        var thumb = document.querySelector('.gallery-thumb[data-image-id="' + match.featured_image.id + '"]');
        if (thumb && !thumb.classList.contains('active')) thumb.click();
      }

      // Update price
      var priceWrap = document.querySelector('.product-price-wrap');
      if (priceWrap) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceWrap.innerHTML =
            '<span class="price-sale">' + formatMoney(match.price) + '</span>' +
            '<span class="price-compare">' + formatMoney(match.compare_at_price) + '</span>' +
            '<span class="price-save-badge">Save ' + formatMoney(match.compare_at_price - match.price) + '</span>';
        } else {
          priceWrap.innerHTML = '<span class="price-regular">' + formatMoney(match.price) + '</span>';
        }
      }

      /* Multi-pair tiers and anything else that shows a per-variant price (2026-10-05) */
      try { document.dispatchEvent(new CustomEvent('tipt:variant', { detail: match })); } catch (e) {}

      // Update add-to-cart button availability
      var atcBtn = document.getElementById('add-to-cart-btn');
      if (atcBtn) {
        if (match.available) {
          atcBtn.disabled = false;
          atcBtn.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Cart';
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Out of Stock';
        }
      }
    }
    /* Sync once at load: the pills, price and hidden id must agree before any
       click (they are rendered from the selected variant in Liquid, this is
       the belt to those braces). */
    syncPills();
    updateSelectedVariant();
  }

  /* --- Product Detail: Quantity Selector -------------------- */
  var qtyMinus = document.querySelector('.qty-minus');
  var qtyPlus  = document.querySelector('.qty-plus');
  var qtyInput = document.getElementById('qty-input');

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v < 99) qtyInput.value = v + 1;
    });
  }
  function clampQty(v) { v = parseInt(v, 10); if (isNaN(v) || v < 1) return 1; return Math.min(v, 99); }
  if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = clampQty(qtyInput.value); });

  /* --- Product Detail: quick quantity picks + multi-pair tier prices (2026-10-05) ---
     JOBST stockings carry 3+/6+ pair automatic discounts; the picks set the
     quantity and the tier box re-prices when the variant changes. */
  var qtyPicks = document.querySelectorAll('.qty-pick');
  function syncQtyPicks() {
    if (!qtyInput) return;
    var q = clampQty(qtyInput.value);
    qtyPicks.forEach(function (b) {
      var on = parseInt(b.dataset.qty, 10) === q;
      b.classList.toggle('active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  if (qtyPicks.length && qtyInput) {
    qtyPicks.forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = clampQty(this.dataset.qty); syncQtyPicks(); });
    });
    ['change', 'input'].forEach(function (ev) { qtyInput.addEventListener(ev, syncQtyPicks); });
    if (qtyMinus) qtyMinus.addEventListener('click', syncQtyPicks);
    if (qtyPlus) qtyPlus.addEventListener('click', syncQtyPicks);
  }
  var multipair = document.getElementById('multipair');
  if (multipair) {
    document.addEventListener('tipt:variant', function (e) {
      var base = e.detail && e.detail.price;
      if (!base) return;
      multipair.dataset.basePrice = base;
      multipair.querySelectorAll('[data-tier-price]').forEach(function (el) {
        el.textContent = formatMoney(Math.round(base * parseFloat(el.dataset.tierPrice)));
      });
    });
  }

  /* --- Product Detail: Add to Cart Form AJAX ---------------- */
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var idInput = document.getElementById('selected-variant-id');
      var variantId = idInput ? parseInt(idInput.value, 10) : null;
      var qty = qtyInput ? clampQty(qtyInput.value) : 1;
      var btn = document.getElementById('add-to-cart-btn');
      if (!btn.dataset.originalHtml) btn.dataset.originalHtml = btn.innerHTML;
      var plan = productForm.querySelector('input[name="selling_plan"]:checked');
      if (variantId) addToCart(variantId, qty, btn, plan && plan.value ? parseInt(plan.value, 10) : null);
    });
  }

  /* --- Cart: delivery preference attribute (signature on delivery) ------
     One delegated handler serves the cart page and the drawer. The value is
     stored with /cart/update.js so it reaches checkout and the admin order
     even though both Checkout buttons are plain links. (2026-10-05) */
  function setCartAttribute(name, value, statusEl, savedMsg) {
    var attrs = {}; attrs[name] = value;
    if (statusEl) statusEl.textContent = 'Saving…';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart/update ' + r.status); return r.json(); })
      .then(function () {
        if (statusEl) {
          statusEl.textContent = (value && savedMsg) ? savedMsg : 'Saved.';
          setTimeout(function () { statusEl.textContent = ''; }, 2500);
        }
        return true;
      })
      .catch(function () {
        if (statusEl) statusEl.textContent = 'Could not save, please try again.';
        return false;
      });
  }
  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || !box.matches) return;
    var wrap = box.closest ? box.closest('.cart-delivery-opts') : null;
    var status = wrap ? wrap.querySelector('[data-cart-attribute-status]') : null;
    if (box.matches('select[data-cart-attribute]')) {
      var sel = box, prev = sel.dataset.prev || '';
      setCartAttribute(sel.dataset.cartAttribute, sel.value, status, 'Saved. Thank you!').then(function (ok) {
        if (!ok) { sel.value = prev; return; }
        sel.dataset.prev = sel.value;
        document.querySelectorAll('select[data-cart-attribute="' + sel.dataset.cartAttribute + '"]').forEach(function (o) {
          if (o !== sel) o.value = sel.value;
        });
      });
      return;
    }
    if (!box.matches('input[data-cart-attribute]')) return;
    var name = box.dataset.cartAttribute;
    var val = box.checked ? (box.value || 'Yes') : '';
    setCartAttribute(name, val, status, box.dataset.savedMsg).then(function (ok) {
      if (!ok) { box.checked = !box.checked; return; }
      document.querySelectorAll('input[data-cart-attribute="' + name + '"]').forEach(function (o) {
        if (o !== box) o.checked = box.checked;
      });
    });
  });

  /* --- Cart Page: Qty Buttons ------------------------------- */
  document.querySelectorAll('.cart-page-qty-minus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.querySelector('.cart-page-qty-input[data-key="' + this.dataset.key + '"]');
      if (input) {
        var v = parseInt(input.value, 10) || 1;
        if (v > 0) { input.value = v - 1; input.dispatchEvent(new Event('change')); }
      }
    });
  });
  document.querySelectorAll('.cart-page-qty-plus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.querySelector('.cart-page-qty-input[data-key="' + this.dataset.key + '"]');
      if (input) {
        var v = parseInt(input.value, 10) || 0;
        if (v < 99) { input.value = v + 1; input.dispatchEvent(new Event('change')); }
      }
    });
  });
  document.querySelectorAll('.cart-page-qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = this.dataset.key;
      var qty = parseInt(this.value, 10);
      if (this.value.trim() === '' || isNaN(qty) || qty < 0) { this.value = this.defaultValue; return; }
      if (qty > 99) { qty = 99; this.value = '99'; }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { if (!r.ok) { throw new Error('cart-change-failed'); } return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (qty === 0) { window.location.reload(); return; }
          /* Patch the page from the returned cart (2026-09-03 desktop audit
             P1-2): line price, quantity, subtotal and item count used to keep
             their old values until a reload. */
          var line = null;
          (cart.items || []).forEach(function (it) { if (it.key === key) line = it; });
          var row = input.closest('.cart-page-item');
          var priceEl = row ? row.querySelector('.cart-item-price') : null;
          if (priceEl && line) priceEl.textContent = formatMoney(line.final_line_price);
          if (line) { input.value = line.quantity; input.defaultValue = String(line.quantity); }
          var subEl = document.querySelector('[data-cart-subtotal]');
          var countEl = document.querySelector('[data-cart-count-label]');
          if (subEl) subEl.textContent = formatMoney(cart.total_price);
          if (countEl) countEl.textContent = cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's');
          updateShipProgress(cart.total_price);
          announceCart('Cart updated. ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ', subtotal ' + formatMoney(cart.total_price) + '.');
        })
        .catch(function () {
          showCartError('Could not update the cart. Please try again.');
          announceCart('Could not update the cart. Please try again.');
        });
    });
  });
  document.querySelectorAll('.cart-item-remove').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();   /* a real /cart/change link for no-JS; JS does it in place */
      var key = this.dataset.key;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (r) { if (!r.ok) { throw new Error('cart-change-failed'); } return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () {
          showCartError('Could not remove the item. Please try again.');
          announceCart('Could not remove the item. Please try again.');
        });
    });
  });

  /* ============================================================
     CATALOGUE: SORT, FILTERS, INFINITE SCROLL
     ============================================================ */

  /* --- Sort: preserve active filters in the URL ------------- */
  var sortSelect = document.querySelector('[data-sort-by]');
  if (sortSelect) {
    var sortInitial = sortSelect.value;
    var sortViaKeyboard = false;
    function navigateSort() {
      if (sortSelect.value === sortInitial) return;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
    /* 2026-09-03 desktop audit P2-5: on Windows, ArrowUp/Down on a closed
       select fires change at once, which used to reload on the first key.
       Keyboard changes wait for Enter or blur; pointer picks navigate now. */
    sortSelect.addEventListener('keydown', function (e) {
      if (e.altKey) return;                       /* Alt+Down opens the native list */
      if (e.key === 'Enter') { sortViaKeyboard = false; navigateSort(); return; }
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'Home' || e.key === 'End' || e.key.length === 1) sortViaKeyboard = true;
    });
    sortSelect.addEventListener('change', function () {
      if (sortViaKeyboard) return;
      navigateSort();
    });
    sortSelect.addEventListener('blur', function () {
      if (!sortViaKeyboard) return;
      sortViaKeyboard = false;
      navigateSort();
    });
  }

  /* --- Mobile filter drawer --------------------------------- */
  var filterToggle  = document.querySelector('[data-filter-toggle]');
  var filterSidebar = document.querySelector('.catalogue-sidebar');
  var filterOverlay = document.querySelector('[data-filter-overlay]');
  var filterClose   = document.querySelector('[data-filter-close]');

  var filterReturnFocus = null;
  var filterAnimTimer = null;

  /* Same Safari 26 display:none pattern as the cart drawer (0.28s slide);
     the overlay already uses [hidden] and needs nothing extra. */
  function filterSettle() {
    clearTimeout(filterAnimTimer);
    filterAnimTimer = setTimeout(function () {
      filterSidebar.classList.remove('is-animating');
    }, 330);
  }

  function openFilters() {
    if (!filterSidebar) return;
    filterReturnFocus = document.activeElement;
    filterSidebar.classList.add('is-animating');
    void filterSidebar.offsetWidth;
    filterSidebar.classList.add('open');
    filterSettle();
    if (filterOverlay) filterOverlay.hidden = false;
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'true');
    lockScroll();
    if (filterClose) filterClose.focus({ preventScroll: true });
  }
  function closeFilters() {
    if (!filterSidebar || !filterSidebar.classList.contains('open')) return;
    filterSidebar.classList.add('is-animating');
    filterSidebar.classList.remove('open');
    filterSettle();
    if (filterOverlay) filterOverlay.hidden = true;
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
    unlockScroll();
    if (filterReturnFocus && document.contains(filterReturnFocus)) {
      filterReturnFocus.focus({ preventScroll: true });
    }
    filterReturnFocus = null;
  }
  if (filterToggle)  filterToggle.addEventListener('click', openFilters);
  if (filterClose)   filterClose.addEventListener('click', closeFilters);
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilters);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && topLayer() === 'filters') closeFilters();
  });

  /* --- Keep the active category visible in the list's scroll zone -- */
  /* Scroll ONLY the sidebar's own scroll container — never the page.
     Element.scrollIntoView() walks up and scrolls EVERY scrollable ancestor,
     so with body{overflow:clip} + an inner content scroller it nudged the
     whole page on load by a per-collection amount (the active link's position
     in the list), causing the inconsistent "jump". Adjusting the nav's own
     scrollTop directly keeps the active link visible without moving anything
     else on the page. */
  (function () {
    var active = document.querySelector('.catalogue-sidebar .sidebar-nav a.active');
    if (!active) return;
    var nav = active.closest('.sidebar-nav');
    if (!nav) return;
    var navRect = nav.getBoundingClientRect();
    var aRect = active.getBoundingClientRect();
    if (aRect.top < navRect.top) {
      nav.scrollTop -= (navRect.top - aRect.top);
    } else if (aRect.bottom > navRect.bottom) {
      nav.scrollTop += (aRect.bottom - navRect.bottom);
    }
  })();

  /* --- Price filter inputs: typeable + validated ------------ */
  document.querySelectorAll('[data-price-filter]').forEach(function (group) {
    var minInput = group.querySelector('[data-price-min]');
    var maxInput = group.querySelector('[data-price-max]');
    if (!minInput || !maxInput) return;

    [minInput, maxInput].forEach(function (input) {
      // Defensive: nothing should block direct keyboard entry into these fields.
      input.removeAttribute('readonly');
      input.removeAttribute('disabled');
      input.style.pointerEvents = 'auto';

      // While typing: keep only digits and a single decimal point. Do NOT reformat
      // (no commas/currency) mid-edit — that happens on blur via the browser, if at all.
      input.addEventListener('input', function () {
        var cleaned = input.value.replace(/[^\d.]/g, '');
        var dot = cleaned.indexOf('.');
        if (dot !== -1) {
          // collapse any extra decimal points
          cleaned = cleaned.slice(0, dot + 1) + cleaned.slice(dot + 1).replace(/\./g, '');
        }
        if (cleaned !== input.value) input.value = cleaned;
      });
    });

    function num(el) { var n = parseFloat(el.value); return isNaN(n) ? null : n; }

    // On blur: clamp non-negative, keep min <= max, and reflect the relationship for a11y.
    minInput.addEventListener('blur', function () {
      var lo = num(minInput), hi = num(maxInput);
      if (lo !== null && lo < 0) { minInput.value = '0'; lo = 0; }
      if (lo !== null && hi !== null && lo > hi) { minInput.value = String(hi); lo = hi; }
      if (lo !== null) maxInput.min = String(lo); else maxInput.removeAttribute('min');
    });
    maxInput.addEventListener('blur', function () {
      var lo = num(minInput), hi = num(maxInput);
      if (hi !== null && hi < 0) { maxInput.value = '0'; hi = 0; }
      if (lo !== null && hi !== null && hi < lo) { maxInput.value = String(lo); hi = lo; }
      if (hi !== null) minInput.max = String(hi); else minInput.removeAttribute('max');
    });
  });

  /* --- Auto-apply filters ------------------------------------
     Checkboxes apply on click; price fields apply on commit
     (Enter or leaving the field). The Apply button stays in the
     markup as the no-JS fallback and is hidden here. Scroll
     position and the mobile drawer's open state survive the
     reload so picking several filters in a row feels seamless. */
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    var filterApplyBtn = filterForm.querySelector('button[type="submit"]');
    if (filterApplyBtn) filterApplyBtn.hidden = true;

    var filterApplying = false;

    function saveCatalogueState() {
      try {
        sessionStorage.setItem('catalogueFilterState', JSON.stringify({
          y: window.scrollY,
          drawer: filterSidebar ? filterSidebar.classList.contains('open') : false,
          s: filterSidebar ? filterSidebar.scrollTop : 0,
          t: Date.now()
        }));
      } catch (e) {}
    }

    /* Debounced: a second or third tap while the first submit was pending
       used to toggle visibly and then be lost in the reload. */
    var applyTimer = null;
    function applyFilters() {
      if (filterApplying) return;
      clearTimeout(applyTimer);
      filterForm.setAttribute('aria-busy', 'true');
      applyTimer = setTimeout(function () {
        filterApplying = true;
        saveCatalogueState();
        filterForm.submit();
      }, 400);
    }

    // Enter in a price field triggers the browser's implicit form
    // submission (fires 'submit'; form.submit() above does not) —
    // save state and block a duplicate programmatic submit.
    filterForm.addEventListener('submit', function () {
      filterApplying = true;
      saveCatalogueState();
    });

    // Checkboxes apply on toggle. The form serializes at submit time,
    // so a just-committed price value rides along with the toggle.
    filterForm.addEventListener('change', function (e) {
      if (e.target.type === 'checkbox') applyFilters();
    });

    // Price fields apply when focus LEAVES the filter form, not on every
    // commit: tabbing min -> max must not submit mid-entry, and a click on
    // a checkbox/Clear-all must let that control drive the navigation
    // (submitting from under a checkbox click would serialize the box
    // before it toggles and silently drop the toggle).
    var priceDirty = false;
    var formPointerDown = false;
    filterForm.addEventListener('input', function (e) {
      if (e.target.hasAttribute('data-price-min') || e.target.hasAttribute('data-price-max')) {
        priceDirty = true;
      }
    });
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (evt) {
      filterForm.addEventListener(evt, function () {
        formPointerDown = true;
        setTimeout(function () { formPointerDown = false; }, 0);
      }, { passive: true });
    });
    // focusout fires after the blur handlers, so min<=max clamping is done.
    filterForm.addEventListener('focusout', function (e) {
      /* Any control leaving the form with a dirty price applies it (Tab from
         Max used to land on Clear all inside the form and never apply). */
      if (!priceDirty) return;
      if (formPointerDown) return;                                        // click landed inside the form
      if (e.relatedTarget && filterForm.contains(e.relatedTarget)) return; // focus stayed inside the form
      applyFilters();
    });

    // Restore scroll + drawer after a filter-triggered reload only
    // (the key is set right before submitting; TTL guards stale state).
    try {
      var rawState = sessionStorage.getItem('catalogueFilterState');
      if (rawState) {
        sessionStorage.removeItem('catalogueFilterState');
        var filterState = JSON.parse(rawState);
        if (filterState && Date.now() - filterState.t < 60000) {
          var restoreY = filterState.y || 0;
          /* Clamp to the (usually shorter) filtered grid so the restore can
             never land in the footer (2026-09-03 desktop audit P2-19). */
          var clampRestore = function (y) {
            var g = document.getElementById('product-grid');
            if (!g) return y;
            var maxY = g.getBoundingClientRect().bottom + window.scrollY - window.innerHeight;
            return Math.max(0, Math.min(y, maxY));
          };
          if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
          window.scrollTo(0, clampRestore(restoreY));
          /* The document is still growing at deferred-script time on a
             phone's tall grid; re-apply once everything has loaded, then
             hand scroll restoration back to the browser. */
          window.addEventListener('load', function () {
            window.scrollTo(0, clampRestore(restoreY));
            if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
          });
          if (filterState.drawer) openFilters();
          if (filterSidebar && filterState.s) filterSidebar.scrollTop = filterState.s;
        }
      }
    } catch (e) {}
  }

  /* --- Infinite scroll (collections + search) --------------- */
  (function () {
    var grid    = document.getElementById('product-grid');
    var pag     = document.querySelector('[data-pagination]');
    var loader  = document.querySelector('[data-infinite-loader]');
    var moreBtn = document.querySelector('[data-infinite-more]');
    if (!grid || !pag) return;

    var nextUrl = pag.getAttribute('data-next-url');
    if (!nextUrl) return; // single page — nothing to lazy-load

    /* Section Rendering API (2026-09-23): when the grid lives inside a
       section, fetch just that section (measured: 5 KB vs 29 KB compressed
       per batch) instead of the whole page with header, footer and inline
       CSS. Only the fetch URL changes; history and data-next-url stay plain
       page URLs. Search results are a section too (sections/search-results). */
    var sectionHost = grid.closest ? grid.closest('[id^="shopify-section-"]') : null;
    var sectionId = sectionHost ? sectionHost.id.replace('shopify-section-', '') : '';
    function fetchUrlFor(url) {
      if (!sectionId) return url;
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
    }
    var pageNum = 1;
    try { pageNum = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10) || 1; } catch (e0) {}
    if (pageNum > 1) {
      /* Arrived on ?page=N (refresh, shared link, Back): keep the numbered
         pages so the earlier ones stay reachable; only Next hands over to
         the loader (2026-09-03 desktop audit P3-7). */
      pag.querySelectorAll('a').forEach(function (a) { if (a.getAttribute('href') === nextUrl) a.hidden = true; });
    } else {
      pag.style.display = 'none';   // JS takes over; markup stays for no-JS users
    }
    var loading  = false;
    var failures = 0;
    var viaButton = false;

    if (moreBtn) {
      moreBtn.hidden = false;
      moreBtn.addEventListener('click', function () { viaButton = true; loadNext(); });
    }

    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'width:100%;height:1px;';
    grid.parentNode.insertBefore(sentinel, loader || null);

    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) loadNext();
    }, { rootMargin: '500px 0px' });
    io.observe(sentinel);

    // Is the trigger currently at/above the bottom of the viewport (+buffer)?
    // Read live each time instead of trusting a cached observer flag.
    function triggerNearViewport() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      return sentinel.getBoundingClientRect().top <= vh + 500;
    }

    function fallbackToPages() {
      io.disconnect();
      if (loader)  loader.hidden  = true;
      if (moreBtn) moreBtn.hidden = true;
      pag.style.display = '';      // bring back numbered pages so the user is never stuck
      pag.querySelectorAll('a[hidden]').forEach(function (a) { a.hidden = false; });
    }

    function loadNext() {
      if (loading || !nextUrl) return;
      loading = true;
      var loadingUrl = nextUrl;
      if (moreBtn) moreBtn.hidden = true;
      if (loader)  loader.hidden  = false;

      // Abort if the request hangs, so the spinner can never pinwheel forever.
      var controller = ('AbortController' in window) ? new AbortController() : null;
      var timer = setTimeout(function () { if (controller) controller.abort(); }, 12000);

      fetch(fetchUrlFor(nextUrl), controller ? { signal: controller.signal } : undefined)
        .then(function (r) {
          // Rate limited — back off and retry rather than fail.
          if (r.status === 429 || r.status === 430) { var e = new Error('throttled'); e.retry = true; throw e; }
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          clearTimeout(timer);
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          var appended = 0;
          if (newGrid) {
            var frag = document.createDocumentFragment();
            while (newGrid.firstElementChild) { frag.appendChild(newGrid.firstElementChild); appended++; }
            grid.appendChild(frag);
            bindQuickAdd(grid);
          }
          loading = false;
          if (loader) loader.hidden = true;

          // The fetched page had no product grid (e.g. password page / error) — bail out cleanly.
          if (appended === 0) { fallbackToPages(); return; }

          /* Tell screen readers, and give keyboard users a landing spot when
             they pressed the button (never on a scroll-triggered load). */
          announceCart(appended + ' more products loaded.');
          if (viaButton) {
            var firstNew = grid.children[grid.children.length - appended];
            var focusEl = firstNew ? (firstNew.querySelector('.product-card-title') || firstNew) : null;
            if (focusEl && focusEl.closest('a')) focusEl = focusEl.closest('a');
            if (focusEl) {
              if (!focusEl.hasAttribute('tabindex')) focusEl.setAttribute('tabindex', '-1');
              focusEl.focus({ preventScroll: true });
            }
          }
          viaButton = false;

          failures = 0;
          /* Back from a product should return to the page the user was
             on, not page 1 with the appended products gone. */
          try { history.replaceState(history.state, '', loadingUrl); } catch (e2) {}
          var newPag = doc.querySelector('[data-pagination]');
          nextUrl = newPag ? newPag.getAttribute('data-next-url') : null;

          if (!nextUrl) {
            io.disconnect();
            if (moreBtn) moreBtn.hidden = true;
            return;
          }
          if (moreBtn) moreBtn.hidden = false;

          // If the trigger is still on-screen (short page / fast scroll), keep
          // loading — one request at a time, gently throttled to stay under limits.
          if (triggerNearViewport()) setTimeout(loadNext, 350);
        })
        .catch(function (err) {
          clearTimeout(timer);
          loading = false;
          if (loader) loader.hidden = true;
          failures++;

          // Throttled: wait longer, then retry automatically (several attempts).
          if (err && err.retry && failures < 6) {
            if (moreBtn) moreBtn.hidden = false;
            setTimeout(function () { if (triggerNearViewport()) loadNext(); }, 1500);
            return;
          }
          // Real, repeated failure: fall back to numbered pages so nothing is lost.
          if (failures >= 3) { fallbackToPages(); }
          else if (moreBtn) { moreBtn.hidden = false; }
        });
    }
  })();

  /* ============================================================
     PREDICTIVE SEARCH
     ============================================================ */
  var searchFormsForOutsideClick = [];
  document.querySelectorAll('[data-search-form]').forEach(function (form) {
    /* The phone drawer's form cannot render above 1180px: skip its controller
       there (2026-09-03 desktop audit P3-20). */
    if (desktopMQ.matches && form.closest('.mobile-nav')) return;
    var input   = form.querySelector('[data-search-input]');
    var results = form.querySelector('[data-search-results]');
    var clearBtn = form.querySelector('[data-search-clear]');
    var status  = form.querySelector('[data-search-status]');
    if (!input || !results) return;

    var debounceTimer = null;
    var lastQuery = '';
    var options = [];        // keyboard-navigable option elements (refreshed per render)
    var activeIndex = -1;

    /* Combobox keyboard support: collect option elements after each render,
       give them ids for aria-activedescendant. */
    function refreshOptions() {
      options = Array.prototype.slice.call(
        results.querySelectorAll('.search-suggest-item, .search-suggest-popular, .search-suggest-all'));
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
      options.forEach(function (opt, i) {
        opt.id = input.id + '-opt-' + i;
        opt.setAttribute('role', 'option');
        opt.setAttribute('aria-selected', 'false');
      });
      if (status) status.textContent = options.length ? options.length + ' suggestions available, use the arrow keys' : '';
    }

    function setActive(i) {
      if (options.length === 0) return;
      if (activeIndex >= 0 && options[activeIndex]) {
        options[activeIndex].classList.remove('is-active');
        options[activeIndex].setAttribute('aria-selected', 'false');
      }
      activeIndex = i;
      if (i < 0) { input.removeAttribute('aria-activedescendant'); return; }
      var opt = options[i];
      opt.classList.add('is-active');
      opt.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', opt.id);
      if (opt.scrollIntoView) opt.scrollIntoView({ block: 'nearest' });
    }

    function show() {
      results.classList.remove('is-stale');
      results.removeAttribute('aria-busy');
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function hideResults() {
      results.hidden = true;
      results.innerHTML = '';
      results.classList.remove('is-stale');
      results.removeAttribute('aria-busy');
      options = [];
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
      input.setAttribute('aria-expanded', 'false');
    }

    function showClear(show) {
      if (clearBtn) clearBtn.hidden = !show;
    }

    function showLoading() {
      /* No-flicker: if suggestions are already showing, keep them visible but
         dimmed while the fresh fetch is in flight, instead of strobing a
         spinner between every keystroke. */
      if (!results.hidden && results.querySelector('.search-suggest-item, .search-suggest-popular')) {
        results.classList.add('is-stale');
        results.setAttribute('aria-busy', 'true');
        setActive(-1); // clear the old highlight so Enter can't open an outdated suggestion
        return;
      }
      results.innerHTML = '<div class="search-suggest-loading" role="presentation"><span class="search-suggest-spinner" aria-hidden="true"></span> Searching…</div>';
      show();
      refreshOptions();
    }

    /* Soft-highlight WHY a suggestion matched: wrap the first occurrence of
       the longest typed word (>= 2 chars) in <mark>. Operates on
       already-escaped text; skips matches adjacent to '&' so it can never
       split an HTML entity like &amp;. */
    function markMatch(escapedText, term) {
      var tokens = term.split(/\s+/).filter(function (t) {
        return t.length >= 2 && /^[\w-]+$/.test(t);
      });
      if (tokens.length === 0) return escapedText;
      tokens.sort(function (a, b) { return b.length - a.length; });
      var safe = tokens[0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var m = new RegExp(safe, 'i').exec(escapedText);
      if (!m) return escapedText;
      var start = Math.max(0, m.index - 6);
      var context = escapedText.slice(start, m.index + m[0].length + 1);
      if (context.indexOf('&') !== -1) return escapedText; // near an entity — skip
      return escapedText.slice(0, m.index) + '<mark>' + m[0] + '</mark>' +
             escapedText.slice(m.index + m[0].length);
    }

    function renderPopular() {
      var raw = form.getAttribute('data-popular') || '';
      var terms = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (terms.length === 0) { hideResults(); return; }
      var action = form.getAttribute('action');
      var html = '<div class="search-suggest-head" role="presentation">Popular searches</div>';
      terms.forEach(function (t) {
        html +=
          '<a class="search-suggest-popular" href="' + action + '?q=' + encodeURIComponent(t) + '&type=product">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
            escapeHtml(t) +
          '</a>';
      });
      results.innerHTML = html;
      show();
      refreshOptions();
    }

    function renderResults(res, term) {
      var products    = res.products || [];
      var collections = (res.collections || []).slice(0, 3);
      var queries     = (res.queries || []).slice(0, 2);
      var action      = form.getAttribute('action');

      if (products.length === 0 && collections.length === 0 && queries.length === 0) {
        results.innerHTML =
          '<div class="search-suggest-empty" role="presentation">No matches for &ldquo;' + escapeHtml(term) + '&rdquo;</div>';
        show();
        refreshOptions();
        return;
      }

      var html = '';

      /* Spelling/completion suggestions from Shopify (resources[type]=query) */
      queries.forEach(function (q) {
        html +=
          '<a class="search-suggest-popular" href="' + action + '?q=' + encodeURIComponent(q.text) + '&type=product">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
            'Search for &ldquo;' + escapeHtml(q.text) + '&rdquo;' +
          '</a>';
      });

      /* Category shortcuts — the store's IA is category-first */
      if (collections.length > 0) {
        html += '<div class="search-suggest-head" role="presentation">Categories</div>';
        collections.forEach(function (c) {
          html +=
            '<a class="search-suggest-popular" href="' + c.url + '">' +
              escapeHtml(c.title) + ' <span aria-hidden="true">&rarr;</span>' +
            '</a>';
        });
      }

      if (products.length > 0) {
        if (queries.length > 0 || collections.length > 0) {
          html += '<div class="search-suggest-head" role="presentation">Products</div>';
        }
        products.forEach(function (p) {
          var imgUrl = p.featured_image ? p.featured_image.url : (p.image || '');
          if (imgUrl && imgUrl.indexOf('cdn.shopify.com') !== -1) imgUrl += (imgUrl.indexOf('?') === -1 ? '?' : '&') + 'width=88';
          var imgHtml = imgUrl
            ? '<img src="' + imgUrl + '" alt="" width="44" height="44" loading="lazy">'
            : '<span class="search-suggest-noimg"></span>';
          var meta = p.product_type || p.vendor || '';
          html +=
            '<a class="search-suggest-item" href="' + p.url + '">' +
              '<span class="search-suggest-thumb">' + imgHtml + '</span>' +
              '<span class="search-suggest-text">' +
                '<span class="search-suggest-title">' + markMatch(escapeHtml(p.title), term) + '</span>' +
                (meta ? '<span class="search-suggest-meta">' + escapeHtml(meta) + '</span>' : '') +
              '</span>' +
            '</a>';
        });
      }

      html +=
        '<a class="search-suggest-all" href="' + action +
        '?q=' + encodeURIComponent(term) + '&type=product">' +
        'See all results for &ldquo;' + escapeHtml(term) + '&rdquo; <span aria-hidden="true">&rarr;</span></a>';

      results.innerHTML = html;
      show();
      refreshOptions();
    }

    var suggestAbort = null;
    function fetchSuggestions(term) {
      var url = '/search/suggest.json'
        + '?q=' + encodeURIComponent(term)
        + '&resources[type]=product,collection,query'
        + '&resources[limit]=7'
        + '&resources[limit_scope]=each'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][prefix]=last'
        // Search these fields so product codes match the dropdown too.
        // 'body' = the product description (where item numbers live).
        // Note the valid names: variants.sku / variants.barcode (NOT "sku").
        + '&resources[options][fields]=title,body,product_type,variants.title,variants.sku,variants.barcode,vendor,tag';

      /* Abort the previous request: on 3G every keystroke's response used to
         download in full before being discarded as stale. */
      if (suggestAbort) suggestAbort.abort();
      suggestAbort = ('AbortController' in window) ? new AbortController() : null;
      var fetchOpts = { headers: { 'Accept': 'application/json' } };
      if (suggestAbort) fetchOpts.signal = suggestAbort.signal;
      fetch(url, fetchOpts)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (input.value.trim() !== term) return; // stale response
          var res = data && data.resources && data.resources.results
            ? data.resources.results : {};
          renderResults(res, term);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          results.innerHTML = '<div class="search-suggest-empty" role="presentation">Couldn\'t load suggestions. Press Search to see results.</div>';
          show();
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      showClear(term.length > 0);
      clearTimeout(debounceTimer);

      if (term.length === 0) { renderPopular(); return; }
      if (term.length < 2) { hideResults(); return; }

      lastQuery = term;
      showLoading();
      debounceTimer = setTimeout(function () { fetchSuggestions(term); }, 220);
    });

    input.addEventListener('focus', function () {
      var term = input.value.trim();
      if (term.length === 0) {
        renderPopular();
      } else if (term.length >= 2 && results.innerHTML) {
        show();
        refreshOptions();
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        showClear(false);
        hideResults();
        input.focus();
      });
    }

    input.addEventListener('keydown', function (e) {
      // Never intercept keys during IME composition (CJK etc.) — those
      // Arrow/Enter presses belong to the composition candidate list.
      if (e.isComposing || e.keyCode === 229) return;
      if (e.key === 'Escape') {
        /* First Escape closes the list only; the panel's own Escape handler
           (document level) gets the second one. */
        if (!results.hidden) { e.stopPropagation(); hideResults(); }
        return;
      }
      if (results.hidden) {
        // ArrowDown on an empty, closed box re-opens popular searches
        if (e.key === 'ArrowDown' && input.value.trim().length === 0) {
          e.preventDefault();
          renderPopular();
        }
        return;
      }
      if (options.length === 0) return;
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          setActive(activeIndex >= options.length - 1 ? 0 : activeIndex + 1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          setActive(activeIndex <= 0 ? options.length - 1 : activeIndex - 1);
          break;
        case 'Home':
          if (activeIndex !== -1) { e.preventDefault(); setActive(0); }
          break;
        case 'End':
          if (activeIndex !== -1) { e.preventDefault(); setActive(options.length - 1); }
          break;
        case 'Enter':
          // Only hijack Enter when an option is actively highlighted;
          // otherwise the form submits to the full results page as before.
          if (activeIndex >= 0 && options[activeIndex] && options[activeIndex].href) {
            e.preventDefault();
            window.location.href = options[activeIndex].href;
          }
          break;
      }
    });

    /* Hover and keyboard share one highlight (2026-09-03 desktop audit P3-9). */
    results.addEventListener('mousemove', function (e) {
      var opt = e.target.closest ? e.target.closest('[role="option"]') : null;
      if (!opt) return;
      var i = options.indexOf(opt);
      if (i !== -1 && i !== activeIndex) setActive(i);
    });
    form.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !form.contains(e.relatedTarget)) hideResults();
    });
    searchFormsForOutsideClick.push({ form: form, hide: hideResults });
  });
  /* One click-outside listener for all search forms (was one per form). */
  document.addEventListener('click', function (e) {
    /* The utility-bar magnifier opens the panel and focuses the input (which
       renders Popular searches); that same click must not count as "outside". */
    if (e.target.closest && e.target.closest('#header-search-toggle')) return;
    searchFormsForOutsideClick.forEach(function (f) { if (!f.form.contains(e.target)) f.hide(); });
  });

  /* --- Escape HTML ------------------------------------------ */
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

})();

/* Print (2026-09-03 desktop audit P2-15): open every accordion so FAQ
   answers and footer lists print, then put them back. */
window.addEventListener('beforeprint', function () {
  document.querySelectorAll('details:not([open])').forEach(function (d) { d.setAttribute('open', ''); d.setAttribute('data-print-opened', ''); });
  document.querySelectorAll('.faq-item:not(.open)').forEach(function (i) { i.classList.add('open'); i.setAttribute('data-print-opened', ''); });
});
window.addEventListener('afterprint', function () {
  document.querySelectorAll('details[data-print-opened]').forEach(function (d) { d.removeAttribute('open'); d.removeAttribute('data-print-opened'); });
  document.querySelectorAll('.faq-item[data-print-opened]').forEach(function (i) { i.classList.remove('open'); i.removeAttribute('data-print-opened'); });
});

/* Theme editor only: re-rendering a section drops every binding above
   (the init runs once). Reloading the preview is the safe answer. */
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function () { window.location.reload(); });
}

/* Footer accordions (2026-08-24): the section renders <details open> so
   desktop and no-JS phones always see the lists; phones start them closed.
   Runs deferred, before first paint in practice. */
(function () {
  if (!window.matchMedia) return;
  var fmq = window.matchMedia('(max-width: 768px)');
  function syncFooter() {
    document.querySelectorAll('details.footer-acc').forEach(function (d) {
      if (fmq.matches) d.removeAttribute('open'); else d.setAttribute('open', '');
      d.classList.add('is-synced');   /* theme.css hides the open lists on phones until this */
      /* Desktop (2026-09-03 desktop audit P2-17): the summaries are inert
         headings, so they leave the Tab order and ignore Enter/Space. */
      var s = d.querySelector('summary');
      if (!s) return;
      s.tabIndex = fmq.matches ? 0 : -1;
      if (!s.dataset.deskBound) {
        s.dataset.deskBound = '1';
        s.addEventListener('click', function (e) { if (!fmq.matches) e.preventDefault(); });
      }
    });
  }
  syncFooter();
  /* Re-run on rotation: above 768px the summaries are inert, so a phone
     turned to landscape with the lists still closed had no way to open them. */
  if (fmq.addEventListener) fmq.addEventListener('change', syncFooter);
  else if (fmq.addListener) fmq.addListener(syncFooter);
})();

/* Footer bottom-bar tint (2026-08-25): #chrome-footer-tint is a 4px slate
   strip Safari 26 samples for its bottom toolbar, mounted ONLY while the
   footer is on screen — elsewhere the bar composites real page content, or
   shows the green body fallback at rest. iOS only: on anything else the
   strip would be a visible line, and over the slate footer it is invisible
   even where tinting is off (private tabs). iPadOS masquerades as Mac,
   hence the maxTouchPoints test. */
(function () {
  var tint = document.getElementById('chrome-footer-tint');
  var footer = document.querySelector('.site-footer');
  if (!tint || !footer || !('IntersectionObserver' in window)) return;
  var isIOS = /iP(hone|ad|od)/.test(navigator.userAgent) ||
              (navigator.maxTouchPoints > 1 && /Mac/.test(navigator.userAgent));
  if (!isIOS) return;
  new IntersectionObserver(function (entries) {
    tint.classList.toggle('on', entries[0].isIntersecting);
  }).observe(footer);
})();
